export default "__VITE_ASSET__B$NF2Uch__"